<template>
  <div id="RingGraph" :style="{ width: width, height: height }" />
</template>
<script>
import echarts from "echarts";

require("echarts/lib/chart/bar");
export default {
  data() {
    //  饼状图

    return {
      chart: null,
      arr: [],
    };
  },

  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "300px",
    },
    // getData: {
    //   type: Array,
    //   default: []
    // },
    title: {
      type: String,
    },
  },
  mounted() { },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.clear();
    this.chart = null;
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar.opened;
    }
  },
  watch: {
    sidebar(val) {
      setTimeout(() => {
        if (this.chart) this.chart.resize();
      }, 150);
    }
  },
  methods: {
    initChart(data) {
      console.log(data,"");
      var total = 0;
      data.forEach((e) => {
        total += e.Value;
      });
      if (total == 0) {
        total = 1;
      }
      var arr = data.map((x) => {
        return {
          value: x.Value,
          name: x.Name + "(" + Math.floor((x.Value / total) * 100) + "%)",
        };
      });
      this.chart = echarts.init(document.getElementById("RingGraph"));
      // const subText = arr.map((i) => i.value).reduce((pre, cur) => pre + cur);

      var _this = this;
      window.addEventListener('resize', function () {
        if (_this.chart) _this.chart.resize();
      });

      // console.log(_this.title)
      this.chart.setOption({
        title: {
          //text: "标签分类汇总 " + data.length,
          subtext: "",
          left: "center",
          y: "bottom",
          textStyle: {
            fontWeight: "none",
            fontSize: "16",
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: "vertical",
        //   icon: 'circle',
        //   left: "left",
        //   textStyle: {
        //     fontSize: 16,
        //     color: "#fff",
        //   },
        //},
        // 图例图例样式
        color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        series: [
          {
            //name: "标签分类汇总",
            type: "pie",
            radius: ["40%", "70%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              }
            },
            label: {
              alignTo: "edge",
              margin: 20,
              show: true,
              fontSize: "16",
              fontWeight: "bold",
            },
            labelLine: {
              show: false,
            },
          },
        ],
      });
    },
  },
};
</script>
